import IconStoreBanner from "assets/icons/store/IconStoreBanner";
import React from "react";
import styled from "styled-components";

const StoreHeader = ({ handleOpenExternalLink }) => {
  const onClickBanner = () => {
    const targetUrl = "https://crm-guide.bodycodi.com/pos_promotion";
    handleOpenExternalLink(targetUrl);
  };

  return (
    <BannerWrap onClick={onClickBanner}>
      <InnerText>
        <span>바디코디 전용 선착순 혜택 곧 마감!</span>
        <p>차원이 다른 토스 포스기</p>
      </InnerText>
      <CustomBannerIcon />
    </BannerWrap>
  );
};

export default StoreHeader;

const BannerWrap = styled.article`
  width: calc(100% - 48px);
  margin: 0 auto;
  padding: 0 0 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
`;

const InnerText = styled.div`
  padding: 0 20px;
  width: 100%;
  height: 70px;
  background-color: #c8e9ffb2;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > span {
    font-size: 12px;
    font-weight: 600;
    color: #437ef3;
  }

  & > p {
    font-size: 16px;
    font-weight: 700;
    color: #3c3f44;
  }
`;

const CustomBannerIcon = styled(IconStoreBanner)`
  position: absolute;
  top: 0;
  right: 10px;
  aspect-ratio: 1.643 / 1;

  & > svg {
    height: 100%;
  }
`;
